import { AsyncEngine } from "./async";
export class MicrotaskEngine extends AsyncEngine {
    schedule() {
        if (this.scheduled) {
            return;
        }
        this.scheduled = true;
        queueMicrotask(() => {
            this.scheduled = false;
            this.flush();
        });
    }
}
